module.exports = __webpack_public_path__ + "img/chrome.3dcaee40.gif";